module.exports = {"210404001":"田屯街道","210404002":"工农街道","210404003":"建设街道","210404004":"和平街道","210404005":"光明街道","210404006":"朴屯街道","210404007":"演武街道","210404008":"五老屯街道","210404009":"古城子街道","210404010":"新民街道","210404011":"李石街道","210404101":"塔峪镇","210404201":"拉古满族乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/210404.json
// module id = 486
// module chunks = 0